import React, { useEffect, useState } from 'react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import Table from 'react-bootstrap/Table';
import {
    DASHBOARD_PATH,
    HOSPITAL_USER_PATH,
    INDIVIDUAL_USER_PATH,
    CREATE_HOSPITAL_ADMIN_PATH_2,
} from '@constants/routes';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import UserDeviceList from './UserDeviceList';
import {
    APPROVED,
    BLOCKED,
    REJECTED,
    WAITING,
} from '@constants/constants';
import { useNavigate } from 'react-router-dom';
import { getUserName, updateUser } from '@utils/utils';
import { addNotes, getUserAttributes, scan } from '@utils/authUtils';
import { TENANT_ID } from '@constants/cognitoAttributes';
import ModalPopUp from '@components/ModalPopUpComponent';
import TextAreaPopUp from '@components/TextAreaPopUpComponent';
import { LuFileX2 } from 'react-icons/lu';
import {
    capitalizeFirstLetter,
    formatDateDMY,
    generateUniqueTimestamp,
    getDataUsingTenantId,
    getHospitalAdminList,
    sendStatusNotification,
} from '@utils/sharedUtils';
import { DEFAULT_PROFILE_SRC } from '@constants/images';
import DataLoader from '@components/DataLoader';
import { setGoToDashboard } from '@store/reducers/userSlice';
import {
    setUserRole,
    setDeviceUniqueID,
    setHospitalName,
    setHospitalBranch,
    setHospitalID,
    setAddressOne,
    setAddressTwo,
    setCity,
    setUserState,
    setCountry,
    setPincode,
    setHospitalWebsite,
    setHospitalEmail,
    setHospitalContact,
    setHospitalGST,
    setFileMetadata,
    setName,
    setEmail,
    setMobileNumber,
    setPassword,
    setAdminCreateHospital,
    setHospitalUser,
    setHospitalTenantId
} from '@store/reducers/auth/signupSlice';
import { HOSPITAL } from '@constants/constants';
import AdminListTable from '@components/Layout/AdminListTable';
import { sendPushNotification } from '@utils/notificationUtils';
import { useAuditLog } from '../../contexts/AuditLogContext';

type Note = {
    text: string;
};

type DeviceDetails = {
    name: string;
    device_id: string;
    date: string;
    id: string;
};

const HospitalDetailPage = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [showUnBlockModal, setShowUnBlockModal] = useState(false);
    const [showTextModal, setShowTextModal] = useState(false);
    const [notes, setNotes] = useState<Note[]>([]);
    const [showModal, setShowModal] = useState(false);
    const userDetail = useAppSelector((state) => state.user.hospitalDetails);
    const userDevice =
        useAppSelector((state) => state.user.userDeviceList) || [];
    const [userStatus, setUserStatus] = useState<string>(
        userDetail?.hospital_admin_status
            ? userDetail?.hospital_admin_status
            : ''
    );
    const [userApprovedOn, setUserApprovedOn] = useState<string>(
        userDetail?.approvedOn
            ? userDetail?.approvedOn
            : ''
    );
    const { addLog } = useAuditLog();
    const [deviceDetails, setDeviceDetails] = useState<DeviceDetails[]>([]);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const loggedInUserTenantID = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );
    const loggedInUserInfoUuid = useAppSelector(
        (state) => state.login.loggedInUserInfoUuid
    );
    const loggedInUserID = useAppSelector(
        (state) => state.login.loggedInUserID
    );
    const goToDashboard = useAppSelector((state) => state.user.goToDashboard);
    const loggedInUserEmail = useAppSelector(
        (state) => state.login.loggedInUserEmail
    );
    const [hospitalAdminList, setHospitalAdminList] = useState<any[]>([]);
    useEffect(() => {
        if (!userDetail) {
            const pathname = location.pathname;
            // Check if the pathname matches any of the paths from AppConfig
            if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
                navigate(HOSPITAL_USER_PATH);
            } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
                navigate(INDIVIDUAL_USER_PATH);
            }
        }

        fetchNotes();
        adminList();
        fetchDeviceDetails();
    }, [location.pathname, userDetail, navigate]);
    const [tableHeading1, setTableHeading1] = useState([
        {
            id: 1,
            title: t('management.hospital.admin_title'),
        },
        {
            id: 2,
            title: t('management.hospital.email_title'),
        },
        {
            id: 3,
            title: t('management.hospital.mobile_num'),
        },
        {
            id: 4,
            title: t('management.hospital.action'),
        },
    ]);

    const adminList = async () => {
        const hosAdminData = await getHospitalAdminList(
            userDetail?.tenantUUid ? userDetail?.tenantUUid : ''
        );
        if (hosAdminData) {
            setHospitalAdminList(hosAdminData);
        }
        [[]];
    };
    const fetchDeviceDetails = async () => {
        try {
            if (userDetail) {
                const hospital = await getUserName(
                    'hospitals',
                    userDetail?.tenantUUid,
                    'tenant_id'
                );
                let assigned = [];
                if (hospital) {
                    const hospitalUuid = hospital[0];
                    const deviceList = await getUserName(
                        'hospital_device',
                        hospitalUuid?.uuid?.S ? hospitalUuid?.uuid?.S : '',
                        'hospital_id'
                    );
                    if (deviceList) {
                        for (const device of deviceList) {
                            const deviceData = await getUserName(
                                'devices',
                                device?.device_id?.S
                                    ? device?.device_id?.S
                                    : '',
                                'uuid'
                            );
                            if (deviceData) {
                                const assignedDevice = deviceData[0];
                                const data = {
                                    name: assignedDevice?.device_name?.S
                                        ? capitalizeFirstLetter(
                                              assignedDevice?.device_name?.S
                                          )
                                        : '',
                                    device_id: assignedDevice?.device_id?.S
                                        ? capitalizeFirstLetter(
                                              assignedDevice?.device_id?.S
                                          )
                                        : '',
                                    date: assignedDevice?.created_at?.S
                                        ? formatDateDMY(
                                              assignedDevice?.created_at?.S
                                          )
                                        : '',
                                    id: assignedDevice?.uuid?.S
                                        ? assignedDevice?.uuid?.S
                                        : '',
                                };
                                assigned.push(data);
                            }
                        }
                    }
                    setDeviceDetails(assigned);
                }
            }
        } catch (error: any) {
            console.log('error:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchNotes = async () => {
        try {
            if (userDetail) {
                const res = await scan('notes', userDetail.tenantUUid);
                if (Array.isArray(res)) {
                    const extractedNotes = res.map((note: any) => ({
                        text: note.notes.S || '',
                    }));
                    setNotes(extractedNotes);
                }
            }
        } catch (error: any) {
            console.log('error:', error.message);
        }
    };

    const getStatusClass = (status: string) => {
        switch (status.toLowerCase().trim()) {
            case 'approved':
                return 'text-white bg-success inline-block rounded px-2 py-1';
            case 'waiting':
                return 'text-white bg-warning inline-block rounded px-2 py-1';
            case 'blocked':
                return 'text-white bg-secondary inline-block rounded px-2 py-1';
            case 'rejected':
                return 'text-white bg-danger inline-block rounded px-2 py-1';
            default:
                return '';
        }
    };

    const now = new Date();
    const formattedDateTime = generateUniqueTimestamp();

    const date = new Date(generateUniqueTimestamp());
    const formattedDate = new Intl.DateTimeFormat('en-GB').format(date);

    const updateStatus = async (status: string) => {
        try {
            const attributes = await getUserAttributes();

            if (typeof attributes === 'string' || attributes === null) {
                return;
            }

            const tenantUuid = attributes[TENANT_ID] ?? '';
            const attributeNames = {
                '#status': 'status',
                '#approved_by': 'approved_by',
                '#approved_on': 'approved_on',
                '#modified_by': 'modified_by',
                '#modified_at': 'modified_at',
            };

            const attributeValues = {
                ':status': { S: status },
                ':approved_by': { S: loggedInUserID },
                ':approved_on': { S: formattedDateTime },
                ':modified_by': { S: tenantUuid },
                ':modified_at': { S: formattedDateTime },
            };

            const updateExpression =
                'SET #status = :status, #approved_by = :approved_by, #approved_on = :approved_on, #modified_by = :modified_by, #modified_at = :modified_at';

            if (!userDetail?.tenantUUid) {
                return;
            }

            const info = await getDataUsingTenantId(
                'hospitals',
                userDetail.tenantUUid
            );
            const userInfo = await getDataUsingTenantId('user_info', userDetail.tenantUUid);
            const hospitalInfo = await getDataUsingTenantId('hospital_info', userDetail.tenantUUid);
            if (!info || !info.Items || !userInfo || !userInfo.Items || !hospitalInfo || !hospitalInfo.Items) {
                return;
            }
            const uuid = info?.Items[0]?.uuid?.S;
            const userInfoUuid = userInfo?.Items[0]?.uuid?.S;
            const userID = userInfo?.Items[0]?.user_id?.S;
            const hospitalInfoUuid = hospitalInfo?.Items[0]?.uuid?.S;

            if (uuid && userInfoUuid && hospitalInfoUuid) {
                await updateUser(
                    'hospitals',
                    uuid,
                    attributeNames,
                    attributeValues,
                    updateExpression
                );
                await updateUser(
                    'user_info',
                    userInfoUuid,
                    attributeNames,
                    attributeValues,
                    updateExpression
                );
                await updateUser(
                    'hospital_info',
                    hospitalInfoUuid,
                    attributeNames,
                    attributeValues,
                    updateExpression
                );
                setUserStatus(status);
                setUserApprovedOn(formattedDate);

                addLog(
                    'Hospital Status Updated',
                    hospitalInfoUuid,
                    'Hospital Info',
                    loggedInUserID,
                    { 'Status': status, 'Hospital': hospitalInfo?.Items[0]?.hospital_name?.S },
                    window.location.hostname
                );
            }

            const email = userInfo?.Items?.[0]?.email?.S;
            const toAddress = email ? email : '';

            if (status.toLowerCase() == BLOCKED.toLowerCase()) {
                // await sendPushNotification({user_id: userID ? userID : '', type: 'blocked', device_id: '', reason: '', assigned_by: loggedInUserID });
                const notificationData = {
                    users: toAddress,
                    status: 'blocked',
                };

                // Send the data to the sharedUtils.ts function
                await sendStatusNotification(notificationData);
            } else if (status.toLowerCase() == APPROVED.toLowerCase()) {
                // await sendPushNotification({user_id: userID ? userID : '', type: 'approved', device_id: '', reason: '', assigned_by: loggedInUserID });
                const notificationData = {
                    users: toAddress,
                    status: 'approved'
                };

                // Send the data to the sharedUtils.ts function
                await sendStatusNotification(notificationData);
            } else if (status.toLowerCase() == REJECTED.toLowerCase()) {
                // await sendPushNotification({user_id: userID ? userID : '', type: 'rejected', device_id: '', reason: '', assigned_by: loggedInUserID });
                const notificationData = {
                    users: toAddress,
                    status: 'rejected'
                };

                // Send the data to the sharedUtils.ts function
                await sendStatusNotification(notificationData);
            }
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    const backArrow = () => {
        if (goToDashboard) {
            dispatch(setGoToDashboard(false));
            navigate(DASHBOARD_PATH);
        } else {
            navigate(HOSPITAL_USER_PATH);
        }
    };
    const handleNotes = async (text: string) => {
        if (loggedInUserTenantID && loggedInUserInfoUuid) {
            const updatedBy = loggedInUserTenantID;

            if (userDetail) {
                await addNotes(
                    updatedBy,
                    text,
                    loggedInUserInfoUuid,
                    userDetail.tenantUUid
                ).then(() => {
                    setNotes((prevNotes) => [
                        ...prevNotes,
                        {
                            text,
                        },
                    ]);
                    setShowTextModal(false);
                });
            }
        }
    };
    function handelHospitalAdmin() {
        dispatch(setUserRole(HOSPITAL));
        dispatch(setAdminCreateHospital(true));
        dispatch(
            setHospitalTenantId(
                userDetail?.tenantUUid ? userDetail?.tenantUUid : ''
            )
        );
        dispatch(setDeviceUniqueID(''));
        dispatch(setHospitalName(''));
        dispatch(setHospitalBranch(''));
        dispatch(setHospitalID(''));
        dispatch(setAddressOne(''));
        dispatch(setAddressTwo(''));
        dispatch(setCity(''));
        dispatch(setUserState(''));
        dispatch(setCountry(''));
        dispatch(setPincode(''));
        dispatch(setHospitalWebsite(''));
        dispatch(setHospitalEmail(''));
        dispatch(setHospitalContact(''));
        dispatch(setHospitalGST(''));
        dispatch(
            setFileMetadata({
                name: '',
                url: '',
                type: '',
            })
        );
        dispatch(setName(''));
        dispatch(setEmail(''));
        dispatch(setMobileNumber(''));
        dispatch(setPassword(''));
        dispatch(setHospitalUser(true));
        navigate(CREATE_HOSPITAL_ADMIN_PATH_2);
    }
    return (
        <>
            <div>
                <div className="flex justify-between">
                    <div className="font-bold text-black">
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={backArrow}
                        >
                            <IoMdArrowRoundBack className="cursor-pointer" />{' '}
                            <div className="ml-2">{t('hospital.hospital_account')}</div>
                        </div>
                    </div>
                    <div>
                        {userStatus.toLowerCase() == WAITING.toLowerCase() && (
                            <>
                                <button
                                    className="!bg-primary py-1 px-3 text-white mr-3"
                                    onClick={() => setShowApproveModal(true)}
                                >
                                    {t('hospital.approve')}
                                </button>
                                <button
                                    className="text-primary py-1 px-3 border border-primary"
                                    onClick={() => setShowModal(true)}
                                >
                                    {t('hospital.reject')}
                                </button>
                            </>
                        )}
                        {userStatus.toLowerCase() == APPROVED.toLowerCase() && (
                            <>
                                <button
                                    className="text-white bg-secondary inline-block py-1 px-3 border"
                                    onClick={() => setShowBlockModal(true)}
                                >
                                    {t('hospital.block')}
                                </button>
                            </>
                        )}
                        {userStatus.toLowerCase() == REJECTED.toLowerCase() && (
                            <button
                                className="!bg-primary py-1 px-3 text-white mr-3"
                                onClick={() => setShowApproveModal(true)}
                            >
                                {t('hospital.approve')}
                            </button>
                        )}
                        {userStatus.toLowerCase() == BLOCKED.toLowerCase() && (
                            <button
                                className="text-primary py-1 px-3 border border-primary"
                                onClick={() => setShowUnBlockModal(true)}
                            >
                                {t('hospital.unblock')}
                            </button>
                        )}
                    </div>
                </div>
                <div className="relative">
                    <div className="circular-image">
                        {userDetail?.logo ? (
                            <img
                                src={userDetail?.logo}
                                alt="Logo"
                                className="object-contain rounded-full mx-auto"
                            />
                        ) : (
                            <img
                                src={DEFAULT_PROFILE_SRC}
                                alt="Logo"
                                className="object-contain rounded-full mx-auto"
                            />
                        )}
                    </div>
                    <div className="bg-white flex flex-col rounded mt-5 p-5">
                        <h1 className="text-text_gray_clr font-semibold mt-5 px-2 ml-5">
                            {t('management.hospital.title2')}
                        </h1>
                        <div className="flex flex-wrap mb-4 pt-4">
                            <div className="flex w-1/2 pl-8 ">
                                <div className="w-1/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black">
                                            {t('nurse_details.hospital_name')}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black">
                                            {t('nurse_details.hospital_id')}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black">
                                            {t(
                                                'management.hospital.hospital_website'
                                            )}
                                        </label>
                                    </div>
                                </div>
                                <div className="w-2/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3">
                                            {userDetail?.hospital_name
                                                ? userDetail?.hospital_name
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3">
                                            {userDetail?.hospital_id
                                                ? userDetail?.hospital_id.toUpperCase()
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3">
                                            {userDetail?.hospital_website
                                                ? userDetail?.hospital_website
                                                : '--'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex w-1/2  pr-4 pl-5">
                                <div className="w-1/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black text-wrap">
                                            {t('management.hospital.gst_no')}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black text-wrap">
                                            {t('management.hospital.mobile_no')}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black text-wrap">
                                            {t('management.hospital.email_id')}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black text-wrap">
                                            {t('nurse_details.address')}
                                        </label>
                                    </div>
                                </div>
                                <div className="w-2/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3 text-wrap">
                                            {userDetail?.gst_no
                                                ? userDetail?.gst_no
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3 text-wrap">
                                            {userDetail?.contact_no
                                                ? userDetail?.contact_no
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3 text-wrap">
                                            {userDetail?.email_id
                                                ? userDetail?.email_id
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3 text-wrap">
                                            {userDetail?.address
                                                ? userDetail?.address
                                                : '--'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-between align-center">
                            <h1 className="text-text_gray_clr font-semibold mt-2 px-2 ml-5">
                                {t('management.hospital.admin_info')}
                            </h1>
                            <h1 className="text-text_gray_clr font-semibold mt-2 pr-[25.5rem]  ml-5">
                                {t('management.hospital.account_info')}
                            </h1>
                        </div>
                        <div className="flex flex-wrap mb-4 pt-4">
                            <div className="flex w-1/2 pl-8 ">
                                <div className="w-1/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black">
                                            {t(
                                                'management.hospital.admin_name'
                                            )}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black">
                                            {t('management.hospital.mobile_no')}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black">
                                            {t('management.hospital.email_id')}
                                        </label>
                                    </div>
                                </div>
                                <div className="w-2/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3">
                                            {userDetail?.admin_name
                                                ? userDetail?.admin_name
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3">
                                            {userDetail?.mobile_no
                                                ? userDetail?.mobile_no
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3">
                                            {userDetail?.admin_email
                                                ? userDetail?.admin_email
                                                : '--'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex w-1/2 pr-4 pl-5">
                                <div className="w-1/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black text-wrap">
                                            {t(
                                                'management.hospital.created_on'
                                            )}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black text-wrap">
                                            {t(
                                                'management.hospital.account_status'
                                            )}
                                        </label>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <label className="font-bold text-black text-wrap">
                                            {t(
                                                'management.hospital.approved_on'
                                            )}
                                        </label>
                                    </div>
                                </div>
                                <div className="w-2/3 flex flex-col">
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3 text-wrap">
                                            {userDetail?.create_date
                                                ? userDetail?.create_date
                                                : '--'}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3 text-wrap">
                                            <div
                                                className={getStatusClass(
                                                    userStatus
                                                )}
                                            >
                                                {userStatus ? userStatus : '--'}
                                            </div>
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center">
                                        <span className="ml-3 text-wrap">
                                            {userApprovedOn ? userApprovedOn : '--'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-between items-center mb-4 mt-5">
                        <h1 className="text-lg font-bold">
                            {t('management.hospital.admin_list')}
                        </h1>
                        <button
                            className="bg-primary rounded ml-4 py-1.5 px-3 text-white w-32"
                            onClick={handelHospitalAdmin}
                        >
                            {t('management.hospital.add_admin')}
                        </button>
                    </div>
                    {/* hospitalAdminList */}
                    <AdminListTable
                        data={hospitalAdminList}
                        header={tableHeading1}
                    />
                    <div className="flex justify-between">
                        <div className="w-2/5 mr-4">
                            <div className="mt-5">
                                <div className="font-bold text-black">
                                    <div className="flex items-center">
                                        <div className="ml-2">
                                            {/* Connected  */}
                                            {t('hospital.device_list')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white flex flex-col rounded-lg mt-4 w-[27rem] h-[29rem] relative">
                                <UserDeviceList deviceList={deviceDetails} />
                            </div>
                        </div>
                        <div className="w-3/5 ml-2">
                            <div className="mt-5 flex justify-between">
                                <div className="font-bold text-black">
                                    <div className="flex items-center">
                                        <div className="ml-2">{t('hospital.notes')}</div>
                                    </div>
                                </div>
                                <div>
                                    <button
                                        className="!bg-primary py-1 px-3 text-white mr-3"
                                        onClick={() => setShowTextModal(true)}
                                    >
                                        {t('hospital.add_notes')}
                                    </button>
                                </div>
                            </div>
                            <div className="bg-white flex flex-col rounded-lg mt-3">
                                <Table>
                                    <tbody>
                                        {notes.length != 0 ? (
                                            <>
                                                {notes.map((note, index) => (
                                                    <tr
                                                        key={index}
                                                        className="border-none"
                                                    >
                                                        <td
                                                            className="border-none text-black"
                                                            colSpan={4}
                                                        >
                                                            <div className="bg-notes py-2">
                                                                <span className="ml-2">
                                                                    {note.text}
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr className="border-none">
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                </tr>
                                                <tr className="border-none">
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                </tr>
                                                <tr className="border-none">
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                    <td className="border-none text-black"></td>
                                                </tr>
                                            </>
                                        ) : (
                                            <>
                                                <tr className="border-none">
                                                    <td
                                                        className="border-none text-center py-5"
                                                        colSpan={4}
                                                    >
                                                        <div className="flex justify-center">
                                                            <LuFileX2
                                                                size={40}
                                                                className="text-secondary"
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalPopUp
                show={showApproveModal}
                message={t('pop_up.hospital_approve')}
                onConfirm={() => {
                    updateStatus(APPROVED);
                    setShowApproveModal(false);
                }}
                onCancel={() => setShowApproveModal(false)}
            />
            <ModalPopUp
                show={showModal}
                message={t('pop_up.hospital_reject')}
                onConfirm={() => {
                    updateStatus(REJECTED);
                    setShowModal(false);
                }}
                onCancel={() => setShowModal(false)}
            />
            <ModalPopUp
                show={showBlockModal}
                message={t('pop_up.hospital_block')}
                onConfirm={() => {
                    updateStatus(BLOCKED);
                    setShowBlockModal(false);
                }}
                onCancel={() => setShowBlockModal(false)}
            />
            <ModalPopUp
                show={showUnBlockModal}
                message={t('pop_up.hospital_unblock')}
                onConfirm={() => {
                    updateStatus(APPROVED);
                    setShowUnBlockModal(false);
                }}
                onCancel={() => setShowUnBlockModal(false)}
            />
            <TextAreaPopUp
                show={showTextModal}
                message={t('pop_up.add_notes')}
                onConfirm={handleNotes}
                onCancel={() => setShowTextModal(false)}
            />
            {loading && <DataLoader />}
        </>
    );
};

export default HospitalDetailPage;
